import { NavLink, Outlet } from 'react-router-dom';
import { Button } from '@/components/Button';
import { AnnouncementBanner } from '@/features/announcement/AnnouncementBanner';
import { useAuth } from '@/features/auth/AuthProvider';

// The Surveillance dropdown was removed 2026-08-27. It had been a group of
// three pages; after /events, /markets and /resolution were removed it held a
// single item, so it was a menu that cost a click to reveal one link. Wallet
// surveillance now sits directly in the bar beside Event surveillance.

export function AppShell() {
  const { user, logout } = useAuth();
  if (!user) return null;
  return (
    <div className="shell">
      <header className="shell__header" aria-label="Primary">
        <NavLink to="/" className="shell__brand">
          <span className="shell__brand-mark" aria-hidden />
          <span>Polymarket Surveillance</span>
        </NavLink>
        <nav className="topnav">
          <NavLink
            to="/event-surveillance"
            className={({ isActive }) => `topnav__link${isActive ? ' is-active' : ''}`}
          >
            Event surveillance
          </NavLink>
          <NavLink
            to="/market-surveillance"
            className={({ isActive }) => `topnav__link${isActive ? ' is-active' : ''}`}
          >
            Market surveillance
          </NavLink>
          <NavLink
            to="/wallets"
            className={({ isActive }) => `topnav__link${isActive ? ' is-active' : ''}`}
          >
            Wallet surveillance
          </NavLink>
          <NavLink
            to="/watchlists"
            className={({ isActive }) => `topnav__link${isActive ? ' is-active' : ''}`}
          >
            Watchlist
          </NavLink>
          <NavLink
            to="/traced"
            className={({ isActive }) => `topnav__link${isActive ? ' is-active' : ''}`}
          >
            Traced
          </NavLink>
          <NavLink
            to="/saved-searches"
            className={({ isActive }) => `topnav__link${isActive ? ' is-active' : ''}`}
          >
            Saved searches
          </NavLink>
          {user.role === 'admin' && (
            <NavLink
              to="/admin/users"
              className={({ isActive }) => `topnav__link${isActive ? ' is-active' : ''}`}
            >
              Admin
            </NavLink>
          )}
        </nav>
        <div className="shell__header-spacer" />
        <div className="shell__header-actions">
          <NavLink to="/account">
            <Button variant="ghost" size="sm">
              {user.email}
            </Button>
          </NavLink>
          <Button variant="ghost" size="sm" onClick={() => void logout()}>
            Sign out
          </Button>
        </div>
      </header>
      <main className="shell__main">
        <AnnouncementBanner />
        <Outlet />
      </main>
    </div>
  );
}
